import { useCallback, useEffect, useState } from "react";
import { getZoomradCards, type ZoomradCard } from "@/api";

interface UseZoomradCardsResult {
  cards: ZoomradCard[];
  isLoading: boolean;
  error: Error | null;
  /** Xatodan keyin qayta urinish */
  reload: () => void;
}

/**
 * Zoomrad foydalanuvchisining kartalari (in-app to'lov uchun).
 *
 * `enabled` — faqat Zoomrad in-app oqimida `true` bo'lishi kerak. Boshqa
 * hostlarda so'rov umuman yuborilmaydi: token Zoomrad'niki bo'lmagani uchun
 * backend xato qaytarardi va foydalanuvchi keraksiz toast ko'rardi.
 */
export function useZoomradCards(enabled: boolean): UseZoomradCardsResult {
  const [cards, setCards] = useState<ZoomradCard[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    if (!enabled) {
      setCards([]);
      setIsLoading(false);
      setError(null);
      return;
    }

    let cancelled = false;
    setIsLoading(true);
    setError(null);

    getZoomradCards()
      .then((rows) => {
        if (!cancelled) setCards(rows);
      })
      .catch((e) => {
        if (!cancelled) {
          setError(e instanceof Error ? e : new Error(String(e)));
          setCards([]);
        }
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [enabled, reloadKey]);

  const reload = useCallback(() => setReloadKey((k) => k + 1), []);

  return { cards, isLoading, error, reload };
}
